export const RESPONSIVE_EMAILS_TEXT = {
    id: 'oe.blueprint.orderBooking.responsiveEmails',
    description: 'Responsive Emails button label on Event Blueprint',
    defaultMessage: 'Responsive Emails',
};

export const CONFIGURE_ORDER_BOOKING_EMAILS_TITLE = {
    id: 'oe.blueprint.orderBooking.configureEmailsTitle',
    description: 'Title for Configure Order Booking emails popup',
    defaultMessage: 'Configure Order Booking emails',
};

export const CONFIGURE_EMAIL_TITLE = {
    id: 'oe.blueprint.orderBooking.configureEmailTitle',
    description: 'Title for Configure email popup',
    defaultMessage: 'Configure email',
};

export const COORDINATOR_BOOKING_CREATED_LABEL = {
    id: 'oe.blueprint.orderBooking.coordinatorBookingCreated',
    description: 'Coordinator Booking Created email option label',
    defaultMessage: 'Coordinator - Booking Created',
};

export const EMAIL_UPDATED_NOTIFICATION = {
    id: 'oe.blueprint.orderBooking.emailUpdatedNotification',
    description: 'Toast after saving Coordinator Booking Created email',
    defaultMessage: 'Coordinator - Booking Created email updated',
};

export const APPLY_TEXT = {
    id: 'oe.common.apply',
    description: 'Apply button text',
    defaultMessage: 'Apply',
};

export const CANCEL_TEXT = {
    id: 'oe.common.cancel',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
};

export const DONE_TEXT = {
    id: 'oe.common.done',
    description: 'Done button text',
    defaultMessage: 'Done',
};

export const EMAIL_SUBJECT_LABEL = {
    id: 'oe.label.emailSubject',
    description: 'Email Subject label',
    defaultMessage: 'Email Subject',
};

export const EMAIL_BODY_LABEL = {
    id: 'oe.label.emailBody',
    description: 'Email Body label',
    defaultMessage: 'Email Body',
};
